<template>
  <span class="sort" @click="sortAction()">
    <i class="el-icon-caret-bottom" v-if="sortAttr.includes('sort')"></i>
    <i class="el-icon-caret-top" v-else></i>
  </span>
</template>
<style lang="scss">
.sort {
  cursor: pointer;
  font-size: 12px;
}
</style>
<script>
export default {
  name: "my-sort",
  props: {
    th: Object,
    name:String,
  },
  data() {
    return {
      sortAttr:"",
    };
  },
  methods: {
    sortAction() {
      this.sortAttr == this.th.value
        ? (this.sortAttr = `${this.th.value}_sort`)
        : (this.sortAttr = this.th.value);
      this.$emit("tableSort",this.sortAttr)
        // this.$store.commit("tableSort",{sortAttr:this.sortAttr,name:this.name});
    }
  }
};
</script>
